// Write your code here
import {Chrono} from 'react-chrono'
import ProjectTimelineCard from '../ProjectTimelineCard'
import CourseTimelineCard from '../CourseTimelineCard'
import './index.css'

const TimelineView = props => {
  const {timelineItemsList} = props

  const renderItemList = item => {
    if (item.categoryId === 'COURSE') {
      return <CourseTimelineCard key={item.id} courseDetails={item} />
    }
    return <ProjectTimelineCard key={item.id} projectDetails={item} />
  }
  return (
    <div className="bg">
      <div>
        <h1 className="heading">
          MY JOURNEY OF
          <span className="sub-heading">
            <br />
            <br />
            CCBP 4.0
          </span>
        </h1>
        <Chrono items={timelineItemsList} mode="VERTICAL_ALTERNATING">
          {timelineItemsList.map(eachItem => renderItemList(eachItem))}
        </Chrono>
      </div>
    </div>
  )
}

export default TimelineView
